import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { OnlineChatButton } from '../../components/Button';
import CardInfo from '../../components/cards/CardInfo';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import RadioList from '../../components/RadioList';
import useSteps from '../../context/steps.context';
import spreadIf from '../../helpers/spreadIf';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
import useCardholders from '../../hooks/useCardholders';
import { t } from '../../translations/getTranslation';
const ListContainer = styled.div `
  margin-top: ${({ theme }) => theme.spacing.large}px;
`;
const HeadingContainer = styled.div `
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.xlarge}px;
`;
const SelectCardholder = () => {
    const { stepsState: { error }, stepsDispatch } = useSteps();
    const { cardholders, selectedCardholders, isLoading } = useCardholders('SelectCardholder');
    const { isSuccess, isSemu } = useAccountSummary();
    const [fireAnalytics, setFireAnalytics] = useState(false);
    const [optionClicked, setOptionClicked] = useState(false);
    const handleReasonChange = (event) => {
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        const cardholderSelected = cardholders.find(singleCardholder => event.currentTarget.value === singleCardholder.name);
        if (!cardholderSelected)
            return;
        stepsDispatch({
            type: 'updateAnswer',
            payload: {
                step: 'SelectCardholder',
                value: [cardholderSelected]
            }
        });
    };
    const handleCardClick = (value) => {
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        stepsDispatch({
            type: 'updateAnswer',
            payload: { step: 'SelectCardholder', value: [value] }
        });
        if (!optionClicked) {
            setOptionClicked(true);
            setFireAnalytics(false);
        }
    };
    useEffect(() => {
        if (!isLoading && cardholders && isSuccess && !optionClicked) {
            setFireAnalytics(true);
        }
    }, [isLoading, cardholders, isSuccess, optionClicked]);
    useAnalytics(fireAnalytics, {
        isSemu,
        error
    });
    return (_jsxs("div", Object.assign({ id: "select-account-view" }, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx("legend", { children: _jsx(LayoutHeading, Object.assign({ modalImageProps: { imageName: 'DISPUTE_TRANSACTION' }, title: t('selectAccount.whichCardholder') }, spreadIf([
                            error,
                            { errorText: t('selectCardholder.selectOne') }
                        ]))) }), _jsxs(ListContainer, { children: [_jsxs(HeadingContainer, { children: [_jsx("p", { children: t('selectCardholder.eligibleCardholders') }), _jsxs("p", { children: [t('selectCardholder.contactUs'), _jsx(OnlineChatButton, { children: t('common.onlineChat') }), t('selectCardholder.toCommunicate')] })] }), cardholders.map(({ id, name, last4digits }) => {
                                var _a;
                                return (_jsx(RadioList, { label: name, subText: t('common.accountEndingIn', {
                                        last4digits: last4digits || ''
                                    }), radioProps: {
                                        id,
                                        name: 'reason-selection',
                                        value: name,
                                        checked: ((_a = selectedCardholders === null || selectedCardholders === void 0 ? void 0 : selectedCardholders[0]) === null || _a === void 0 ? void 0 : _a.id) === id,
                                        /* @ts-expect-error TODO: fix handle typing in CL. */
                                        onChange: handleReasonChange,
                                        children: null,
                                        hasError: !!error
                                    }, onClick: () => handleCardClick({ id, name, last4digits }) }, id));
                            })] })] }))] })));
};
export default SelectCardholder;
//# sourceMappingURL=index.js.map